import _ from 'lodash';

export class MapUtil {

  async getLocalPosition():Promise<{lat?:number,long?:number}> {

    // no access to location
    if(!navigator.geolocation)
      return Promise.resolve({});
    
    // we have access to the location
    return new Promise((resolve, reject) => {

      let ret:{lat?:number,long?:number, address?:string} = {};

      // we use the geolocation APIs
      navigator.geolocation.getCurrentPosition((position) => {

        ret.lat = position.coords.latitude;
        ret.long = position.coords.longitude;

        return resolve(ret);
      });
    });
  }

  async geocode(googleRef:any, lat:number, long:number):Promise<{address?:string}> {
    
    // we have a location let's reverse geo locate it (if the google object is available)
    const geocoder = googleRef && googleRef.maps && new googleRef.maps.Geocoder();
    
    return new Promise((resolve, reject) => {

      if(!geocoder)
        return resolve({});

      // we reverse geolocate
      geocoder.geocode({location: {lat:lat, lng:long}}, (results:any[], status:string) => {
        if (status !== 'OK' || results.length === 0)
          return resolve({});
        
        const firstResult = results.find(result => result.formatted_address !== undefined)

        if(!firstResult)
          return resolve({});

        // we return
        return resolve({address: firstResult.formatted_address});
      })

    });

  }

}

